module.exports = __webpack_public_path__ + "img/works_beijing_xikemu_2.f8e7441a.png";